import { Nullable } from '@common/typescript/objects/Nullable';
import { WithId } from '@common/typescript/objects/WithId';

export interface LabelPaperMargins {
	left: number;
	right: number;
	top: number;
	bottom: number;
}

export interface LabelPaperTypography {
	titleFontSize: number;
	headerFontSize: number;
	baseFontSize: number;
}

export interface LabelPaper extends WithId {
	name: string;
	description: string;

	printQr: boolean;
	printIcon: boolean;

	crematoryId: Nullable<number>;

	margins: LabelPaperMargins;
	labelPaddings: LabelPaperMargins;
	typography: LabelPaperTypography;

	width: number;
	height: number;
	unit: LengthUnit;

	rows: number;
	columns: number;

	spacing: Spacing;
}

export enum Orientation {
	Landscape = 0,
	Portrait = 1,
}

export enum LengthUnit {
	Millimeter = 0,
	Centimeter = 1,
	Inch = 2,
}

export interface Spacing {
	column: number;
	row: number;
}
